import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailInfoboxComponent } from '../../components/email-infobox/email-infobox.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailRecruiteeLogoComponent } from '../../components/email-recruitee-logo/email-recruitee-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { EmailMailgunIfDirective } from '../../directives/email-mailgun-if.directive';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import type { WrappedValue } from '../../mailgun/wrap-value';

@Component({
  selector: 'email-company-deletion-request-created-template',
  styleUrls: ['../../global-styles.less', './company-deletion-request-created.component.less'],
  templateUrl: './company-deletion-request-created.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailRecruiteeLogoComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailLinkComponent,
    EmailInfoboxComponent,
    EmailMailgunIfDirective,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
})
export class CompanyDeletionRequestCreatedTemplateComponent {
  @Input({ required: true }) public data: WrappedValue<CompanyDeletionRequestCreatedTemplateData>;
}

export type CompanyDeletionRequestCreatedTemplateData = {
  header: string;
  title_html: string;
  note_body_html: string;
  footer: string;
  avatar_url: string;
  support_email: string;
};

export const CompanyDeletionRequestCreatedTemplateMocks: CompanyDeletionRequestCreatedTemplateData[] =
  [
    {
      header: 'Request for company account deletion.',
      title_html:
        "<a href='#'><b>John Doe</b></a> has just submitted a request to <b>delete the ACME company account</b>.",
      note_body_html:
        '<p>The <b>deletion of ACME</b> is now pending and the company account has been locked. All company data will be <b>permanently deleted in 14 days</b>.</p>',
      footer:
        "You've received this email because you're an admin at ACME company. If there are any problems with this deletion request, please contact our support team.",
      avatar_url: 'https://cdn3.iconfinder.com/data/icons/business-avatar-1/512/7_avatar-64.png',
      support_email: 'support@recruitee.com',
    },
  ];
